import React, {Component} from 'react';
const {connect} = require('react-redux');

import HeaderFollow from './follow/HeaderFollow';
import FollowersList from 'containers/member/follow/FollowersList';
import Pagination from 'components/Pagination';
import Loading from 'components/Loading';
import Footer from '../../components/Footer';

import '../../sass/follow.scss';

import {getMemberFollowed} from 'reducers/memberFollowed';

import {t} from 'l10n';
import queryString from "query-string";
import paths from 'paths';
import {FOLLOWERS_PER_PAGE} from "../../constants/profiles";
import {diff} from "deep-object-diff";

class MemberFollowed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: this.constructor.getSearchObject(props)
        };
    }

    static getSearchObject({location}) {
        let query = queryString.parse(location.search);
        if(!query.order) query.order = "status";
        return query;
    }

    static fetchData({dispatch, location, params}) {
        let query = this.getSearchObject({location});

        let reducerParams = {
            limit: FOLLOWERS_PER_PAGE,
            offset: ((query.page || 1) - 1) * FOLLOWERS_PER_PAGE,
            order: query.order,
            desc: query.desc,
            ...params
        };

        return dispatch(getMemberFollowed(reducerParams));
    }

    componentDidMount() {
        let {dispatch, location, memberFollowed} = this.props;

        //let newSearchObj = this.constructor.getSearchObject(this.props);

        //if (!memberFollowed.list || Object.keys(diff(this.state.search, newSearchObj)).length) {
            this.constructor.fetchData({dispatch, location});
        //}
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            search: this.constructor.getSearchObject(nextProps)
        });
    }

    componentWillUpdate(nextProps, nextState) {
        let searchDiff = diff(this.state.search, nextState.search);

        if (Object.keys(searchDiff).length) {
            let {dispatch, location} = nextProps;

            this.constructor.fetchData({dispatch, location});
        }
    }

    render() {
        let {memberFollowed} = this.props,
            {list, totalCount} = memberFollowed;

        let {page, order, desc} = this.state.search;
        desc = desc == 1 ? 1 : 0;

        if (!list) {
            return <Loading centered/>
        }

        return (
            <div id="wrapper" className="ui-kit-base">
                <HeaderFollow title={t('My followers')} showForm={false}/>

                <aside className="follow-members">
                    <div className="content">
                        <h2 className="ui-header">{t('Followers')} <span>{totalCount}</span></h2>
                        <FollowersList list={list} pathname={paths.memberFollowers.path} page={page} order={order} desc={desc ? 1 : 0}/>
                        <Pagination
                            currentPage={page || 1}
                            itemsPerPage={FOLLOWERS_PER_PAGE}
                            totalCount={totalCount}
                            urlFn={(page) => ({pathname: paths.memberFollowers.path, search: queryString.stringify({page: page, order: order, desc: desc ? 1:0})})}
                        />
                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberFollowed: state.memberFollowed
    }),
    null
    /*({
        getMemberFollowed: getMemberFollowed,
    })*/
)(MemberFollowed);


// WEBPACK FOOTER //
// ./src/containers/member/MemberFollowed.js